module.exports = __webpack_public_path__ + "img/icon_1.5a82767f.png";